<div class="send-body">
    <div class="send-container" [ngClass]="{'has-promotion': hasPromotion}">
        <app-upload-progress class="col left-col" [progress]="progress$ | async" [isMainDomain]="isMainDomain$ | async"
            [totalSizeUploaded]="totalSizeUploaded$ | async" [totalSizeToUpload]="totalSizeToUpload$ | async" [speed]="speed$ | async"
            [remainingTime]="remainingTime$ | async" [selectedTeam]="selectedTeam$ | async" [uploadMode]="uploadFormMode$ | async"
            [uploadStatus]="uploadStatus$ | async" [transfer]="transfer$ | async" [hasPromotion]="hasPromotion"
            [ngClass]="{'promotionLoaded': state === 'loadingFinished', 'has-promotion': hasPromotion}" [showMyAccount]="showMyAccount"
            [showDiscoverSmash]="showDiscoverSmash" (cancelClicked)="onCancelClicked()" (smashAgainClicked)="onSmashAgainClicked()">
        </app-upload-progress>
        <div class="col right-col" *ngIf="(theme$ | async)?.reveal || hasPromotion" [ngClass]="{'promotionLoaded': state === 'loadingFinished'}">
            <div class="placeholder">
                <ng-container *ngIf="(theme$ | async)?.reveal; else promotionTemplate">
                    <app-smash-reveal [theme]="theme$ | async"></app-smash-reveal>
                </ng-container>
                <ng-template #promotionTemplate>
                    <app-smash-promotion [replay]="replay" [promotion]="promotion$ | async"></app-smash-promotion>
                </ng-template>
            </div>
        </div>
    </div>
</div>